module.exports = __webpack_public_path__ + "static/media/sum_assured.15b68736.svg";